<template>
  <div class="setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4">
        <div class="input-group">
          <span class="input-group-addon">账号/姓名</span>
          <input class="form-control" v-model="keyWord" placeholder="输入关键字查询">
        </div>
      </div>
    </div>

    <div class="table-wrap">
      <table class="table table-bordered table-condensed">
        <thead>
          <tr>
            <th style="min-width:120px;">时间</th>
            <th style="min-width:120px;">账号</th>
            <th style="min-width:120px;">名称</th>
            <th style="min-width:120px;">IP</th>
            <th style="min-width:120px;">城市</th>
          </tr>
        </thead>
        <tbody v-if="filtered.length">
          <tr v-for="row in filtered" :key="row.ID">
            <td>{{ row.LoginDateTime }}</td>
            <td>{{ row.LoginName }}</td>
            <td>{{ row.UserName }}</td>
            <td>{{ row.PublicIP }}</td>
            <td>{{ row.RegionInfo || row.CityName }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-muted" style="padding:6px 0;">
        共 {{ filtered.length }} 条
        <span v-if="sourceTotal">（Ivan 源共 {{ sourceTotal }}，前端展示最近 {{ list.length }}）</span>
      </div>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'

export default {
  name: 'LoginLogView',
  data() {
    return {
      loading: false,
      list: [],
      sourceTotal: 0,
      keyWord: ''
    }
  },
  computed: {
    filtered() {
      const kw = String(this.keyWord || '').trim().toLowerCase()
      if (!kw) return this.list
      return this.list.filter(row => {
        const hay = `${row.LoginName || ''} ${row.UserName || ''} ${row.PublicIP || ''} ${row.RegionInfo || ''}`.toLowerCase()
        return hay.indexOf(kw) >= 0
      })
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('login_log.json')
        this.list = data.dataList || []
        this.sourceTotal = data._sourceTotal || (data.pager && data.pager.allDataCount) || this.list.length
      } catch (e) {
        this.$message.error(e.message || '加载登陆日志失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.setting-page { height: 100%; overflow: auto; padding: 8px; }
.table-wrap { overflow: auto; }
</style>
